import ProjectListingScrollItem from './ProjectListingScrollItem';

export default ProjectListingScrollItem;
